import { builder } from 'common/js/configs';

export const formatConfigUnmarshaller = {
  useBtnAutoMargin: builder.boolean('use_btn_auto_margin', {
    defaultValue: false
  }),
  backgroundTransparent: builder.boolean('background_transparent', {
    defaultValue: false
  })
};
